<template>
  <div class="page-XLaboutUs container-fluid" ref="box" id="aboutUs">
    <div class="box-padding">
      <div class="XLaboutUs-text animate__animated animate__slow" ref="title">
        <h1 class="title">关于浦创智能</h1>
        <p class="title-en title">About Us</p>
        <div class="content">
          <p>
            浦创智能是一家拥有自主知识产权及研发能力的前装智能汽车座舱一体化零部件供应商，
            是集研发、制造、服务为一体，致力于引领新一代驾乘体验的科技型企业。公司设立上海研发中心
            、长春软件中心、深圳技术中心，并在江苏常州和江苏东台拥有先进的智能制造工厂。
            公司已完成AR-HUD、W-HUD和车载冰箱等多款智能化产品的研发和量产，与多家头部主机厂建立了深度的合作关系，并在国内外市场取得了显著的商业成就。
          </p>
          <p>
            依托强大的研发实力、持续的技术创新和经验丰富的团队，自行设计、研发、生产的HUD和车载冰箱产品已获得多项行业内标杆奖项及知识产权，彰显出公司的高度专业化和行业领先地位。
            不仅实现了产品在性能、成本、用户体验等方面的行业领先优势，同时满足了汽车厂商对差异化、低成本、快速迭代的市场需求。
          </p>
          <p>
            展望未来，浦创智能将继续深耕智能座舱领域，以技术创新为核心，拓展全球市场，致力于成为智能座舱增量市场的行业龙头，为驾乘者提供卓越的出行体验，
            同时为未来汽车智能化技术的发展贡献力量。
          </p>
        </div>
        <div class="XLaboutUs-img content" ref="XLaboutUs-img">
          <img src="../style/img/picture.png" alt="" />
        </div>
      </div>

      <div
        class="XLaboutUs-box row justify-content-around mt-4 animate__animated animate__slower"
        ref="XLaboutUs-content"
      >
        <div class="col-md-12 col-lg-4 mt-4 pl-xl-0 content-box">
          <div class="XLaboutUs-box-background mission p-4">
            <div class="img">
              <img src="../style/img/mission.png" alt="" />
            </div>
            <div class="content mt-5">
              <h5 class="text-light">使命</h5>
              <p>通过我们的产品 <br />让人们拥有不一样的车享生活</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-4 mt-4 content-box">
          <div class="XLaboutUs-box-background values p-4">
            <div class="img">
              <img src="../style/img/values.png" alt="" />
            </div>
            <div class="content mt-5">
              <h5 class="text-light">价值观</h5>
              <p>诚信 &nbsp;&nbsp;尽责 &nbsp;&nbsp;合作 &nbsp;&nbsp;创新</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-4 mt-4 pr-xl-0 content-box">
          <div class="XLaboutUs-box-background management p-4">
            <div class="img">
              <img src="../style/img/management.png" alt="" />
            </div>
            <div class="content mt-5">
              <h5 class="text-light">口号</h5>
              <p>初心不忘共成长<br />凝心聚力谱新篇</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XLaboutUs",

  data() {
    return {
      oldScrollTop: 0,
    };
  },
  methods: {
    handleScroll() {
      let _this = this;
      let refArray = [
        {
          ref: "title",
          height: 0,
          animate: "animate__slideInUp",
        },
        {
          ref: "XLaboutUs-content",
          height: 0,
          animate: "animate__slideInUp",
        },
      ];
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      if (scrollStep < 0) {
        refArray.forEach((r) => {
          var a, c, d;
          a = this.$refs["XLaboutUs-content"].offsetTop;
          c = scrollTop; //  获取窗口滚动条高度
          d =
            document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
          if (c + d < a) {
            this.$refs[r.ref].classList.remove(r.animate);
          }
        });
      } else {
        refArray.forEach((r) => {
          _this.$utils.gdjz(this.$refs[r.ref], r.height, r.animate, () => {
            window.requestAnimationFrame(function () {
              _this.$refs[r.ref].classList.add(r.animate);
            });
          });
        });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 960px) {
  .page-XLaboutUs {
    padding-top: 10rem !important;
  }
}
.page-XLaboutUs {
  padding-top: 8rem;
  border-radius: 10px;
  // background-image: url(../style/img/picture4.png);
  // background-position: center 100%;
  // background-repeat: no-repeat;
  //   box-shadow: 0 0 10px rgb(0, 153, 184) inset, 0 0 30px rgb(0, 153, 184);
  .box-padding {
    padding: 0 10%;
  }
  @media (max-width: 960px) {
    .box-padding {
      padding: 0;
    }
  }
  .XLaboutUs-text {
    text-align: center;
    .title {
      font-size: 2rem;
      color: #fff;
    }
    .title-en {
      color: #ffffff6e;
      font-size: 1.2rem;
    }
    .content {
      padding: 20px 60px 20px;
      p {
        font-size: 1.2rem;
        color: #ffffff;
        line-height: 40px;
        text-align: left;
        text-indent: 2em;
      }
    }
    @media (max-width: 960px) {
      .content {
        padding: 20px 0 20px;
      }
    }
  }
  .XLaboutUs-img {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
      transition: all 0.6s;
    }
    img:hover {
      transform: scale(1.1);
    }
  }
  .row {
    margin: 0;
  }
  @media (max-width: 960px) {
    .XLaboutUs-box {
      padding: 20px 20px 20px !important;
    }
  }
  .XLaboutUs-box {
    padding: 20px 60px 20px;
    .XLaboutUs-box-background {
      background-color: rgba(245, 250, 255, 0.1);
      // background-image: url(../style/img/picture2.png);
      border-radius: 10px;
      .img {
        padding-right: 1.6rem;
      }
      .content {
        padding-left: 3rem;
        .text-light {
          color: #fff;
          font-size: 1.6rem;
        }
        p {
          color: #fff;
          font-size: 1.2rem;
        }
      }
      @media (max-width: 1024px) {
        .content {
          padding-left: 1rem;
        }
      }
    }
    .XLaboutUs-box-background:hover {
      // background-image: url(../style/img/picture3.png) !important;
      animation-name: xing;
      animation-duration: 1s;
      animation-fill-mode: forwards;
      box-shadow: 0 0 10px #ffffff00 inset, 0 0 5px #ffffff47;
      background-color: rgba(245, 250, 255, 0.15);
    }
    .mission {
      height: 100%;
      .img {
        text-align: right;
        img {
          width: 12%;
          height: 10%;
        }
      }
      .content {
        p {
          color: #ffffff;
          line-height: 40px;
        }
      }
    }
    .values {
      height: 100%;
      .img {
        text-align: right;
        img {
          width: 12%;
          height: 10%;
        }
      }
      .content {
        p {
          color: #ffffff;
          line-height: 40px;
        }
      }
    }
    .management {
      height: 100%;
      .img {
        text-align: right;
        img {
          width: 12%;
          height: 10%;
        }
      }
      .content {
        p {
          color: #ffffff;
          line-height: 40px;
        }
      }
    }
  }
}

@keyframes xing {
  100% {
    transform: scale(1.05);
  }
}
@media (max-width: 540px) {
  .content-box {
    // padding-left: 1rem;
    height: 19rem;
  }
}
</style>
